import { render, staticRenderFns } from "./SSOButtonSection.vue?vue&type=template&id=47fe993c&scoped=true"
import script from "./SSOButtonSection.vue?vue&type=script&lang=js"
export * from "./SSOButtonSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe993c",
  null
  
)

export default component.exports